import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
// import EntityTagPicker from 'Modules/.common/components/NewEntityTagPicker';
import { Select } from "@gpstrackit/gtc-react-controls";
import { Stepper } from 'Components';
import { Grid } from "@mui/material";
import { NotificationManager } from 'Components/Notifications';

//Views
import Summary from 'Modules/.common/components/CameraSetup/.components/cameraConfig/summary';
import Main from 'Modules/.common/components/CameraSetup/.components/cameraConfig/main';

//Hooks
import { useNewEntityTag } from 'Core/hooks';

//Actions
import { cameraSetupUpdateUnits, cameraAccountCameraTypes } from '../../redux/slice';
import { catalogLoad } from 'Redux/actions';
import TagsManage from "Modules/.common/components/TagsManage";

const ALL_CAMERAS_ENTITY_ID = "All";
const ALL_CAMERAS_UNITS_ID = "all";

const BukConfig = (props) => {
    const { currentStep, deviceModelSelected, setDeviceModelSelected, selectedCameras, setSelectedCameras, cameraChanges, vehicleClass, vehicleClassOptions, searchTags } = props
    const { messages } = useIntl();
    const [entitySelected, setEntitySelected] = useState({ id: ALL_CAMERAS_ENTITY_ID, label: "All" });
    const dispatch = useDispatch();
    const allCamerasLabel = messages["cameraSetup_all_cameras"];

    //Redux States
    const deviceModels = useSelector(state => state.cameraSetupRedux.deviceModels)
    const errorUnitsSelected = useSelector(state => state.cameraSetupRedux.errorUnitsSelected)

    // TagsManage no renderiza lista ni dispara onChange con entidad "All"; replica EntityTagPicker (onOptionChange id "all").
    useEffect(() => {
        if (entitySelected?.id !== ALL_CAMERAS_ENTITY_ID || currentStep !== 1) return;
        searchTags([]);
        const isAlreadyAll =
            selectedCameras?.length === 1 && selectedCameras[0]?.id === ALL_CAMERAS_UNITS_ID;
        if (isAlreadyAll) return;
        const allOption = {
            id: ALL_CAMERAS_UNITS_ID,
            label: allCamerasLabel,
            unitId: ALL_CAMERAS_UNITS_ID,
            unitLabel: allCamerasLabel,
        };
        setSelectedCameras([allOption]);
        dispatch(cameraSetupUpdateUnits([allOption]));
    }, [
        entitySelected?.id,
        currentStep,
        allCamerasLabel,
        selectedCameras,
        dispatch,
        setSelectedCameras,
        searchTags,
    ]);

    useEffect(() => {
        if (entitySelected?.id !== "Unit") return;
        const onlySyntheticAll =
            selectedCameras?.length === 1 && selectedCameras[0]?.id === ALL_CAMERAS_UNITS_ID;
        if (!onlySyntheticAll) return;
        setSelectedCameras([]);
        dispatch(cameraSetupUpdateUnits([]));
    }, [entitySelected?.id, selectedCameras, dispatch, setSelectedCameras]);
    
    useEffect(() => {
        if (!deviceModels.length) {
            dispatch(cameraAccountCameraTypes())
        }
        dispatch(catalogLoad(['cameras'], false, true))
    }, [])

    useEffect(() => {
        if (errorUnitsSelected) {
            NotificationManager.error(
                messages["cameraSetup_error_units_unselected"],
                messages["error"],
                5000,
                null,
                null,
                "error"
            )
        }
    }, [errorUnitsSelected])

    const entityTagsSchedule = useNewEntityTag(
        ["Unit"],
        messages['entitySelect'],
        "calc(100vh - 320px)",
        messages['optionSelect'],
        'entities',
    )

    return (
        <div style={{ margin: '15px 25px', height: '80vh' }}>
            <Stepper
                activeStep={currentStep}
                steps={
                    [
                        messages['cameraSetup_deviceModel'],
                        messages['cameraSetup_cameras'],
                        messages['cameraSetup_config'],
                        messages['cameraSetup_summary']
                    ]
                }
            />
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
                style={{ marginBottom: 5 }}
            >
                {
                    currentStep === 0 && (
                        <Grid item xs={12}>
                            <div className="entity-tag-picker-label-min" style={{ marginBottom: 5 }}><span className="entity-tag-picker-span-left">{messages['cameraSetup_select_device_model']}</span></div>
                            <Select
                                id="device-models-list"
                                value={deviceModelSelected}
                                options={deviceModels?.length ? deviceModels.map((item) => ({ ...item, label: messages[`manage_cameraManagement_${item?.label}`] || item?.label })) : []}
                                isMulti={false}
                                isSearchable={true}
                                placeholder={messages['cameraSetup_deviceModel']}
                                textField={"label"}
                                valueField={"id"}
                                style={{ width: '100%' }}
                                onChange={(value) => setDeviceModelSelected(value)}
                            />
                        </Grid>
                    )
                }
                {
                    currentStep === 1 && (
                        <Grid item xs={12}>
                            {/* <EntityTagPicker
                                {...entityTagsSchedule}
                                module={'camera-setup-bulk'}
                                onChangeEntity={(newEntity) => {
                                    searchTags(value)
                                    entityTagsSchedule.onChangeEntity(newEntity)
                                }}
                                onOptionChange={(newOption) => {
                                    if (newOption?.id === "all") {
                                        setTimeout(() => {
                                            setSelectedCameras([newOption])
                                            dispatch(cameraSetupUpdateUnits([newOption]))
                                        }, 100)
                                    }
                                    entityTagsSchedule.onOptionChange(newOption)
                                }}
                                options={[
                                    { id: "all", label: messages["cameraSetup_all_cameras"] },
                                    { id: "entities", label: messages["cameraSetup_cameras"] },
                                    { id: "tags", label: messages['cameraSetup_tags'] }
                                ]}
                                values={selectedCameras}
                                entityLabelClass='camera-setup-label'
                                entityButtonClass='camera-setup-buttons'
                                includeInactiveDrivers={entityTagsSchedule?.includeInactiveDrivers}
                                useIncludesInactive={`${entityTagsSchedule?.entity?.id}-${entityTagsSchedule?.option?.id}`}
                                modeCameras
                                priorityDeviceModel={deviceModelSelected?.id}
                                onChange={(value) => {
                                    if(entityTagsSchedule?.option?.id === "tags"){
                                        searchTags(value)
                                    }
                                    setSelectedCameras(value)
                                    let currentList = value.map((item) => ({ ...item, unitId: item?.id, unitLabel: item.label }))
                                    dispatch(cameraSetupUpdateUnits(currentList))
                                }}
                            /> */}
                            <TagsManage
                                data-testid="cameraSetup-tags"
                                entities={[
                                    { id: ALL_CAMERAS_ENTITY_ID, label: "All" },
                                    { id: "Unit", label: "Unit" }
                                ]}
                                entitySelected={entitySelected}
                                setEntitySelected={setEntitySelected}
                                height={250}
                                hideTagsWithoutEntities={true}
                                mode='list'
                                videoUnits={true}
                                deviceModelSelected={deviceModelSelected}
                                value={selectedCameras}
                                onChange={(value) => {
                                    if(entityTagsSchedule?.option?.id === "tags"){
                                        searchTags(value)
                                    }
                                    setSelectedCameras(value)
                                    let currentList = value.map((item) => ({ ...item, unitId: item?.id, unitLabel: item.label }))
                                    dispatch(cameraSetupUpdateUnits(currentList))
                                }}
                            />
                        </Grid>
                    )
                }
                {
                    currentStep === 2 && (
                        <Grid item xs={12}>
                            <Main
                                {...props}
                                bulkMode
                            />
                        </Grid>
                    )
                }
                {
                    currentStep === 3 && (
                        <Grid item xs={12}>
                            <Summary
                                changes={cameraChanges}
                                vehicleClass={vehicleClass}
                                vehicleClassOptions={vehicleClassOptions}
                            />
                        </Grid>
                    )
                }
            </Grid>
        </div>
    )
}

export default BukConfig